module.exports = __webpack_public_path__ + "static/media/trophy-yield-green.60fd8b9c.webp";